<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col>
                    <div class="font-weight-bold mt-6 title-page">Recuperação de Senha</div>
                    <p class="mt-2">
                        Informe o seu e-mail de acesso para iniciar a recuperação da sua senha.
                    </p>
                </v-col>
            </v-row>
            <v-form ref="form" v-model="validForm">
                <v-row>
                    <v-col>
                        <v-text-field id="username" label="E-mail" v-model="dataset.data.email" required
                            :rules="[$rules.required, $rules.email]" outlined hide-details="auto">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-text>
            <v-btn color="primary" @click.native="finish" :loading="loading">Finalizar</v-btn>
            <v-btn color="grey" text @click.native="goBack">Cancelar</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import 'moment/locale/pt-br';

import { eventHub } from "@/main";

import axios from "axios"

import router from '../../router';

export default {
    data: () => ({
        loading: false,
        validForm: false,
        dataset: {
            data: {}
        }
    }),

    mounted: function () {
    },

    created() {
        this.dataset.data = {}
    },

    methods: {

        goBack() {
            eventHub.$emit('DIALOG-FORGOT-PASSWORD', false)
        },

        async finish() {

            if (!this.$refs.form.validate()) return;

            let data = {
                email: this.dataset.data.email,
            };

            this.loading = true;

            try {
                const result = await axios.post('/api/users/forgot-password', data);

                if (!result.data.status) throw new Error();

                await this.$dialog.confirm({
                    text: 'E-mail enviado com sucesso! Siga as instruções enviadas para recuperar sua conta.',
                    title: 'Sucesso',
                    actions: {
                        true: 'OK'
                    }
                })

                this.goBack();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.data = {}
                this.loading = false;
            }
        },

    }
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

p {
    text-align: justify;
}
</style>
